import React from "react";
import ResultsTableContainer from "./containers/ResultsTableContainer";

const Results = () => {
  return (
    <div className="results">
      <div className="results-headingContainer">
        <h3>Results</h3>
      </div>
      <ResultsTableContainer />
    </div>
  );
};

export default Results;



// WEBPACK FOOTER //
// ./src/Results.js